import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useParams,
} from "react-router-dom";

// Contextos
import { AppConfigContextProvider } from "./contexts/AppConfigContext";
import { FiltersContextProvider } from "./contexts/FiltersContext";
import { OrderContextProvider } from "./contexts/OrderContext";
import { PluginspaceContextProvider } from "./contexts/PluginspaceContext";
import { SellerContextProvider } from "./contexts/SellerContext";
import AuthProvider from "./contexts/authContext";

//Páginas
import { CardPayment } from "./pages/CardPayment";
import { Cart } from "./pages/Cart";
import { Category } from "./pages/Category";
import { Customer } from "./pages/Customer";
import { Favorites } from "./pages/Favorites";
import { Filter } from "./pages/Filter";
import { FilterPDV } from "./pages/Filter/PDV";
import { FinalizeOrder } from "./pages/FinalizeOrder";
import { Home } from "./pages/Home";
import { OrderInfo } from "./pages/OrderInfo";
import { PDV } from "./pages/PDV";
import { Product } from "./pages/Product";
import { QRCodePayment } from "./pages/QRCodePayment";
import { QRCodeSeller } from "./pages/QRCodeSeller";
import { Receipt } from "./pages/Receipt";
import { SearchOrders } from "./pages/SearchOrders";
import { SellerLogin } from "./pages/SellerLogin";
import { Subcategory } from "./pages/Subcategory";
import { SuccessOrder } from "./pages/SuccessOrder";
import { FoodProducts } from "./pages/Food/Products";
import { FoodProduct } from "./pages/Food/Product";
import { Initial } from "./pages/Initial";
import { SellerOrder } from "./pages/SellerOrders";
import { Queue } from "./pages/Queue";
import { QueueFind } from "./pages/QueueFind";
import { SellerCustomer } from "./pages/SellerCustomer";
import { Booking } from "./pages/Booking";
import { BookingSuccess } from "./pages/BookingSuccess";
import { BookingPhone } from "./pages/BookingPhone";
import { BookingUpdate } from "./pages/BookingUpdate";
import { BookingPayment } from "./pages/BookingPayment";
import ScrollToTop from "./contexts/ScrollTop";
import { CategoryContextProvider } from "./contexts/CategoryContext";
import { ProductsContextProvider } from "./contexts/ProductsContext";
import { AuthPage } from "./pages/Auth/Auth";

import { PerfilPage } from "./pages/Perfil/perfil";
import { AccountPage } from "./pages/Account/Account";
import { PerfilInfo } from "./pages/Perfil/info/info";
import { CustomerPage } from "./pages/CustomerOrder/customerOrder";
import { FilterSellerCart } from "./pages/FilterSellerCarts/FilterSellerCart";
import ScrollContextProvider from "./contexts/ScrollContext";
import { NewCartLogin } from "./pages/newCart/newCart";

import { ResetPage } from "./pages/ResetPassword";
import { usePluginspace } from "./hooks/usePluginspace";
import { useEffect } from "react";

import { SellerDashboard } from "./pages/SellerDashboard";
import { FoodProductsNew } from "./pages/Food/Products/new";
import { StoreInfo } from "./pages/StoreInfo/storeInfo";
import { ChatIA } from "./pages/ChatIA";
import { NewCart } from "./pages/NewCheckoutCart/newCheckout";
import { NewCustomer } from "./pages/newCustomer/newCustomer";
import { NewOrderInfo } from "./pages/NewOrderInfo/NewOrderInfo";
import { NewChoosePayment } from "./pages/NewChoosePayment/NewChoosePayment";
import { NewOrderFinalize } from "./pages/newOrderFinalize/NewOrderFinalize";
import { NewSuccessOrder } from "./pages/NewSuccessOrder/NewSuccessOrder";
import { ModalFoodPedidoGarcom } from "./components/ModalFoodPedidoGarcom/ModalFoodPedidoGarcom";
import { FoodContextProvider } from "./contexts/foodConfigContext";
import { ToastContextProvider } from "./contexts/toastContext";
import { Catalog } from "./pages/Catalog/catalog";
import { SellerCalogs } from "./pages/SellerCatalogs/sellerCatalogs";
import { SuccessOrderFood } from "./pages/SuccessOrderFood/SuccessOrderFood";
import { NewChatIa } from "./pages/NewIaChat/page";
import { DiscountProvider } from "./contexts/discountContext";
import { ClearSaleProvider } from "./contexts/ClearSaleContext";
import { PDVFiltered } from "./pages/PDVFiltered/PDVFiltered";
import { CategoriesList } from "./pages/CategoryList";
import ListCatalog from "./pages/ListCatalogs";
import { PDVFilteredCategory } from "./pages/PDVFiltered/PDVFilteredCategory";

export function AppRoutes() {
  const { pluginspace } = usePluginspace();
  function hasLogin() {
    if (pluginspace && pluginspace.appLogin) {
      return true;
    }
    return false;
  }
  return (
    <Router>
      <PluginspaceContextProvider>
        <AppConfigContextProvider>
          <AuthProvider>
            <ClearSaleProvider>
              <DiscountProvider >
                <OrderContextProvider>
                  <FoodContextProvider>
                    <FiltersContextProvider>
                      <SellerContextProvider>
                        <CategoryContextProvider>
                          <ProductsContextProvider>
                            <ScrollContextProvider>
                              <ToastContextProvider>
                              <ScrollToTop />
                              <Routes>
                                <Route path="/" element={<Initial />} />
                                <Route
                                  path="/:pluginspace_id"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/card/:card_number"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/table/:table_number"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/card/:card_number/:card_name"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/table/:table_number/:table_name"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/internal-delivery/:internal_number/:internal_name"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/synkar/:landmark_synkar"
                                  element={<Home />}
                                />
                                <Route
                                  path="/:pluginspace_id/counter/:counter_number"
                                  element={<Home />}
                                />

                                <Route
                                  path="/:pluginspace_id/seller"
                                  element={<SellerLogin />}
                                />
                                <Route
                                  path="/:pluginspace_id/category"
                                  element={<Category />}
                                />

                                <Route
                                  path="/:pluginspace_id/category-list"
                                  element={<CategoriesList />}
                                />

                                  <Route
                                  path="/:pluginspace_id/catalog-list"
                                  element={<ListCatalog />}
                                />


                                <Route
                                  path="/:pluginspace_id/subcategory/:category_id"
                                  element={<Subcategory />}
                                />
                                <Route
                                  path="/:pluginspace_id/pdv/:category_id"
                                  element={<PDV />}
                                />

                                <Route
                                  path="/:pluginspace_id/pdv/filtro"
                                  element={<PDVFiltered />}
                                />

                                <Route
                                  path="/:pluginspace_id/pdv/:category_id/filtro"
                                  element={<PDVFilteredCategory />}
                                />
                                <Route
                                  path="/:pluginspace_id/pdv"
                                  element={<PDV />}
                                />
                                <Route
                                  path="/:pluginspace_id/filter"
                                  element={<Filter />}
                                />
                                <Route
                                  path="/:pluginspace_id/filter/pdv"
                                  element={<FilterPDV />}
                                />
                                <Route
                                  path="/:pluginspace_id/favorites"
                                  element={<Favorites />}
                                />
                                <Route
                                  path="/:pluginspace_id/product/:product_id"
                                  element={<Product />}
                                />
                                <Route
                                  path="/:pluginspace_id/cart"
                                  element={<Cart />}
                                />
                                <Route
                                  path="/:pluginspace_id/customer"
                                  element={<Customer />}
                                />
                                <Route
                                  path="/:pluginspace_id/order"
                                  element={<OrderInfo />}
                                />
                                <Route
                                  path="/:pluginspace_id/card"
                                  element={<CardPayment />}
                                />
                                <Route
                                  path="/:pluginspace_id/order-finalize"
                                  element={<FinalizeOrder />}
                                />
                                <Route
                                  path="/:pluginspace_id/order-qrcode"
                                  element={<QRCodePayment />}
                                />
                                <Route
                                  path="/:pluginspace_id/seller-qrcode"
                                  element={<QRCodeSeller />}
                                />
                                <Route
                                  path="/:pluginspace_id/receipt"
                                  element={<Receipt />}
                                />
                                <Route
                                  path="/:pluginspace_id/success-order"
                                  element={<SuccessOrder />}
                                />
                                <Route
                                  path="/:pluginspace_id/search-order"
                                  element={<SearchOrders />}
                                />
                                <Route
                                  path="/:pluginspace_id/sellerOrder"
                                  element={<SellerOrder />}
                                />
                                <Route
                                  path="/:pluginspace_id/sellerCatalogs"
                                  element={<SellerCalogs />}
                                />

                                <Route
                                  path="/:pluginspace_id/products/:product_id"
                                  element={<FoodProduct />}
                                />
                                <Route
                                  path="/:pluginspace_id/products"
                                  element={<FoodProducts />}
                                />
                                <Route
                                  path="/:pluginspace_id/products-new"
                                  element={<FoodProductsNew />}
                                />
                                <Route
                                  path="/:pluginspace_id/queue"
                                  element={<Queue />}
                                />
                                <Route
                                  path="/:pluginspace_id/queue/:phone"
                                  element={<QueueFind />}
                                />
                                <Route
                                  path="/:pluginspace_id/booking"
                                  element={<Booking />}
                                />
                                <Route
                                  path="/:pluginspace_id/booking/payment"
                                  element={<BookingPayment />}
                                />
                                <Route
                                  path="/:pluginspace_id/booking/:phone"
                                  element={<BookingPhone />}
                                />
                                <Route
                                  path="/:pluginspace_id/booking/update/:id"
                                  element={<BookingUpdate />}
                                />
                                <Route
                                  path="/:pluginspace_id/booking/success/:phone"
                                  element={<BookingSuccess />}
                                />
                                <Route
                                  path="/:pluginspace_id/sellerCustomer"
                                  element={<SellerCustomer />}
                                />

                                <Route
                                  path="/:pluginspace_id/seller-dashboard"
                                  element={<SellerDashboard />}
                                />

                                <Route
                                  path="/:pluginspace_id/store-info"
                                  element={<StoreInfo />}
                                />

                                <Route
                                  path="/:pluginspace_id/chat-ia-old"
                                  element={<ChatIA />}
                                />

                                <Route
                                  path="/:pluginspace_id/chat-ia"
                                  element={<NewChatIa />}
                                />

                                <Route
                                  path="/:pluginspace_id/filter_seller_cart"
                                  element={<FilterSellerCart />}
                                />

                                <Route path="">
                                  {/* Auth */}
                                  <Route
                                    path="/:pluginspace_id/auth/*"
                                    element={<AuthPage />}
                                  />

                                  {/* Registro */}
                                  <Route
                                    path="/:pluginspace_id/register/*"
                                    element={<AccountPage />}
                                  />

                                  {/* Reset Password */}
                                  <Route
                                    path="/:pluginspace_id/reset_password/*"
                                    element={<ResetPage />}
                                  />

                                  {/* Profile */}
                                  <Route
                                    path="/:pluginspace_id/profile/*"
                                    element={<PerfilPage />}
                                  />

                                  {/* Pedidos */}
                                  <Route
                                    path="/:pluginspace_id/my_orders/*"
                                    element={<CustomerPage />}
                                  />

                                  {/* new Cart */}
                                  <Route
                                    path="/:pluginspace_id/new_cart"
                                    element={<NewCartLogin />}
                                  />
                                </Route>

                                {/*Novas Rotas da tela de Checkout */}
                                {/*Aqui é o novo Carrinho de compra*/}
                                <Route
                                  path="/:pluginspace_id/new-cart"
                                  element={<NewCart />}
                                />
                                <Route
                                  path="/:pluginspace_id/new-customer"
                                  element={<NewCustomer />}
                                />
                                <Route
                                  path="/:pluginspace_id/new-order"
                                  element={<NewOrderInfo />}
                                />
                                <Route
                                  path="/:pluginspace_id/new-choose-payment"
                                  element={<NewChoosePayment />}
                                />
                                <Route
                                  path="/:pluginspace_id/new-order-finalize"
                                  element={<NewOrderFinalize />}
                                />
                                <Route
                                  path="/:pluginspace_id/new-success-order"
                                  element={<NewSuccessOrder />}
                                />

                                <Route
                                  path="/:pluginspace_id/catalog/:id_catalog"
                                  element={<Catalog />}
                                />

                                <Route
                                  path="/:pluginspace_id/success_order_food"
                                  element={<SuccessOrderFood />}
                                />
                              </Routes>

                              {/*Modal utilizaod para os pedidos do FOOD (Comanda e Mesa) */}
                              <ModalFoodPedidoGarcom />
                            </ToastContextProvider>
                          </ScrollContextProvider>
                        </ProductsContextProvider>
                      </CategoryContextProvider>
                    </SellerContextProvider>
                  </FiltersContextProvider>
                </FoodContextProvider>
              </OrderContextProvider>
            </DiscountProvider>
            </ClearSaleProvider>
          </AuthProvider>
        </AppConfigContextProvider>
      </PluginspaceContextProvider>
    </Router>
  );
}
